import { types, flow } from 'mobx-state-tree';
import moment from 'moment';
import { getTags } from '../api/tags';
import { api, handleResponse } from '../api';

const Page = types
  .model('Page', {
    isLoading: types.optional(types.boolean, false),
  })
  .views(self => ({
    get parsed() {
      return {
        ...self.toJSON(),
        createdAt: moment(self.createdAt).format('LL'),
        updatedAt: moment(self.updatedAt).format('LL'),
      };
    },
  }));

const AppStore = types
  .model('AppStore', {
    isLoading: types.optional(types.boolean, false),
    tags: types.optional(types.array(types.string), []),
    editorPaused: types.optional(types.boolean, false),
    editMode: types.optional(types.boolean, false),
    pageIsEditable: types.optional(types.boolean, false),
  })
  .actions(self => {
    const setPageIsEditable = state => {
      self.pageIsEditable = state;
    };

    const setIsLoading = state => {
      self.isLoading = state;
    };

    const toggleIsLoading = () => {
      self.isLoading = !self.isLoading;
    };

    const setTags = data => {
      self.tags = data;
    };

    const setPaused = state => {
      self.editorPaused = state;
    };

    const setEditMode = state => {
      self.editMode = state;
    };

    const loadAllTags = flow(function*() {
      const response = yield getTags();
      handleResponse([
        [
          200,
          () => {
            setTags(response.data);
          },
        ],
        [
          'default',
          () => {
            console.log('error loading tags');
          },
        ],
      ])(response);
      return response;
    });
    return {
      setPaused,
      setIsLoading,
      toggleIsLoading,
      loadAllTags,
      setEditMode,
      setPageIsEditable,
    };
  });

export { AppStore };
